import { FormControl, FormHelperText, MenuItem, Select } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { CreateInvoiceForm } from '../../helpers/createInvoiceSchema';
import { map } from 'lodash';

const INVOICE_CATEGORIES = [
  { id: 1, name: 'Cancellation Fee' },
  { id: 2, name: 'Late Fee' },
  { id: 3, name: 'No Show Fee' },
  { id: 4, name: 'Other' },
];

export default function InvoiceCategoryTypeIdField() {
  const {
    control,
    formState: { errors },
  } = useFormContext<CreateInvoiceForm>();

  return (
    <Controller
      control={control}
      name="payment_category_type_id"
      render={({ field: { value, ...field } }) => (
        <FormControl fullWidth>
          <Select {...field} displayEmpty value={value ?? ''} error={!!errors.payment_category_type_id}>
            {map(INVOICE_CATEGORIES, (item) => (
              <MenuItem key={item.id} value={item.id}>
                {item.name}
              </MenuItem>
            ))}
          </Select>
          {!!errors.payment_category_type_id && (
            <FormHelperText error>{`${errors.payment_category_type_id.message}`}</FormHelperText>
          )}
        </FormControl>
      )}
    />
  );
}
